import { motion } from "framer-motion";
import { TRUST_METRICS } from "../lib/constants";

export const Trust = () => {
  return (
    <section
      data-testid="trust-section"
      className="relative bg-[#050B14] py-24 md:py-32 border-y border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12 items-end mb-16">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-6">
              <span className="text-xs tracking-[0.3em] uppercase text-[#D1B677] font-medium">
                Trust & Credibility
              </span>
            </div>
            <h2 className="font-serif text-white text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.1]">
              Premium quality control.{" "}
              <span className="italic text-[#D1B677]">Trust-first ecosystem.</span>
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-[#A1AEBF] text-base leading-relaxed">
              Verified listings only. Structured onboarding standards. Goa-focused,
              globally aligned — the kind of platform serious capital expects.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 border-l border-t border-white/8">
          {TRUST_METRICS.map((m, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              data-testid={`trust-metric-${i}`}
              className="border-r border-b border-white/8 p-8 md:p-12 hover:bg-[#0C5A48]/10 transition-colors duration-500"
            >
              <div className="font-serif text-[#D1B677] text-4xl md:text-5xl lg:text-6xl leading-none mb-4">
                {m.value}
              </div>
              <div className="text-xs tracking-[0.2em] uppercase text-[#A1AEBF]">
                {m.label}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Trust;
